import { render, staticRenderFns } from "./MascotBody.vue?vue&type=template&id=c1064e22&scoped=true&"
import script from "./MascotBody.vue?vue&type=script&lang=ts&"
export * from "./MascotBody.vue?vue&type=script&lang=ts&"
import style0 from "./MascotBody.vue?vue&type=style&index=0&id=c1064e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1064e22",
  null
  
)

export default component.exports